<template>
  <div>
    <div
        class="modal-dialog load"
        v-if="modalToggle"
    >
        <div class="modal-content">
            <div class="modal-header">
                <div>
                    <h4>読込</h4>
                </div>
            </div>
            <div class="modal-body flex_center">
                <input
                    id="xmlfile"
                    type="file"
                    accept=".xml"
                    style="visibility:hidden"
                    @change="fileChoice"
                />
                <p>
                    <span v-if="choicedFileName == null">保存したファイルを指定して下さい。</span>
                    <span v-else>{{choicedFileName}}</span>
                </p>
                <app-button
                    value="ファイルを選択"
                    @button-click="selectFile"
                    this-class="btn_file"
                />
            </div>
            <div class="modal-footer">
                <app-button
                    value="キャンセル"
                    @button-click="cancel"
                    this-class="btn_cancel"
                />
                <app-button
                    value="読込"
                    @button-click="load"
                    this-class=""
                />
            </div>
        </div>
    </div>
  </div>
</template>

<script>
/**
 * XML読み込み用モーダル
 * 
 * [イベント処理]
 * 「ファイルを選択」ボタン押下時 ... document.getElementById("xmlfile").click()
 * ファイルが選択されたとき ... ファイル情報とファイル名をdataに保存
 * 「読込」ボタン押下時 ... XMLファイルが選択されていれば読み込んでモーダルを閉じる、それ以外は警告
 * 「キャンセル」ボタン押下時 ... モーダルを閉じる
 * 
 * [利用例]
 * <modal-load
 *     v-if="modalLoadShow"
 *     @load="loadFile"
 *     @modal-load-hide="hideLoad"
 * />
 * 
 * [データ]
 * modalToggle ... 本モーダルの表示制御、表示するときはtrue
 * choicedFileName ... 選択されたファイル名
 * choicedFile ... 選択されたファイルの情報
 */
export default {
    name:"ModalLoad",
    data(){
        return {
            /**
             * 本モーダルの表示制御、表示するときはtrue
             */
            modalToggle: true,
            /**
             * 選択されたファイル名
             */
            choicedFileName: null,
            /**
             * 選択されたファイルの情報
             */
            choicedFile:{},
        }
    },
    methods: {
        /**
         * ファイル選択画面を開く(実質的には<input type="file">への入力動作)
         */
        selectFile(){
            document.getElementById("xmlfile").click()
        },
        /**
         * 選択されたファイルの情報を取得する
         */
        fileChoice(event){
            this.choicedFileName = event.target.files[0]['name']
            this.choicedFile = event.target.files[0]
        },
        /**
         * XMLファイルが選択されていれば読み込んでモーダルを閉じる、それ以外は警告
         */
        load(){
            if(this.choicedFileName != null && this.choicedFileName.endsWith('.xml')){
                this.$emit('load', this.choicedFile)
            } else {
                alert('XMLファイルを選択して下さい。')
            }
        },
        /**
         * モーダルを閉じさせる
         */
        cancel(){
            this.$emit('modal-load-hide')
        }
    },
}
</script>

<style lang="scss" scoped>
.load .modal-content{
    width: 500px;
}
div.modal-dialog{
    display: block;
    width: 100%;
    height: 100%;
    min-height: 80vh;
    padding: 0;
    margin: 0;
    background-color: rgba(0, 0, 0, 0.2);
    position: fixed;
    overflow-y:auto;
    -ms-overflow-style:none;
    top: 0;
    z-index: 9999;
}
_:-ms-lang(x)::-ms-backdrop, div.modal-dialog {
    overflow: hidden;
}

.modal-content{
    display: block;
    width: 75%;
    max-height: 90vh;
    margin:  65px auto;
    padding: 1em 4em;
    background-color: white;
    border-radius: 5px;
    box-shadow: 0 5px 15px 2px rgba(0, 0, 0, 0.5);
}
.modal-header{
    display: grid;
    grid-template-columns: 10em 1fr;
    -ms-grid-columns: 10em 1fr;/* IE11 */
    align-items: center;
    h4{
        letter-spacing: 0.25em;
    }
}
.modal-lang{
    grid-column: 2;
    -ms-grid-column: 2;
    text-align: end;
    label{
        margin: 0 8px;
        &:after{
            display: none;
        }
    }
}
.modal-body{
    display: block;
    height: auto;
    max-height: 50vh;
    overflow-x: hidden;
    overflow-y: scroll;
}
.modal-body.flex_center{
    display: flex;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin-bottom: 2rem;
}
.modal-body input[type="button"]{
    margin: 8px auto;
}
.modal-body p{
    text-align: center;
}
.modal-body::-webkit-scrollbar {
  display: none;
}
.modal-footer{
    display: flex;
    justify-content: flex-end;
}
input[type="file"]{
    height:0;
    width:0;
}
</style>


